import { Label } from "./Label.js";

export class DataManager {

    public data: IImmoData = null;

    constructor() {

    }

    public async load(url: string) {
        this.data = await e5.load("json", url, {
            onProgress: (e) => {
                // console.log("LOADED", e.loaded / e.total);
            }
        });

        Label.parse(this.data.bis_label);

        for (var cat of this.data.bis_immo_category) {

            if (!cat.immos) {
                cat.immos = [];
            }

            var immos: VOImmo[] = [];
            for (var catId of cat.immos) {
                var immo = this.data.bis_immo.id(catId as any);
                if (immo) {
                    immos.push(immo);
                }
            }
            cat.immos = immos;
        }

        if (this.data.bis_catetory_id) {
            var cat = this.data.bis_immo_category.id(this.data.bis_catetory_id);
            if (cat) {

                if (this.data.bis_immo.length != cat.immos.length) {
                    console.warn("The immos set by the category is not matching the list of given immos.");
                    this.data.bis_immo.sort((a, b) => {
                        return a.title.localeCompare(b.title);
                    });
                } else {
                    this.data.bis_immo = cat.immos;
                }
            }
        }

        for (var immo of this.data.bis_immo) {
            var c = this.data.bis_immo_category.id(immo.category as any);
            if (!c) {
                console.warn("Could not resolve category: " + immo.category);
            }

            if (immo.size) {
                //Int or Float
                // if (immo.size.match(/^([0-9]*[.])?[0-9]+$/)) {
                if (/^([0-9]*[.])?[0-9]+$/.test(immo.size)) {
                    immo.size = immo.size.toString().replace(".", ",") + " ha";
                }
            }

            if (immo.available_area) {
                //Int or Float

                // if (immo.available_area.match(/^([0-9]*[.])?[0-9]+$/)) {
                if (/^([0-9]*[.])?[0-9]+$/.test(immo.available_area)) {
                    immo.available_area = immo.available_area.toString().replace(".", ",") + " ha";
                }
            }

            immo.category = c;
            if (immo.polygon) {
                try {
                    // immo.polygon = JSON.parse(immo.polygon as any);
                    // this.switchLatLng(immo.polygon);
                    immo.polygon = this.convertToGeoJson(immo.polygon as any);
                } catch (error) {
                    console.warn("Could not parse GeoJSON feature.", immo.title, immo.polygon);
                    immo.polygon = null;
                }
            } else {
                immo.polygon = null;
            }
        }

        // console.log(this.data);
    }


    private convertToGeoJson(poly: string): GeoJSON.Feature<GeoJSON.Polygon | GeoJSON.MultiPolygon> {
        var pos = JSON.parse(poly);

        if (poly.indexOf("Feature") !== -1) {
            return pos;
        }

        this.switchLatLng(pos);
        var p = new L.Polygon(pos);
        return p.toGeoJSON();
    }

    private switchLatLng(latlngs: any): void {
        var flat = L.LineUtil.isFlat(latlngs);
        for (var i = 0, len = latlngs.length; i < len; i++) {
            if (flat) {
                var m: [number, number] = latlngs[i];
                var a = m[0];
                m[0] = m[1];
                m[1] = a;
            } else {
                this.switchLatLng(latlngs[i]);
            }
        }
    }
}